class EcomTrafficCrossSell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('.et-cross-sell__slider');
    this.progressBar = this.querySelector('.et-cross-sell__progress-bar');
    
    this.initSlider();
    this.initVariantSelectors();
    this.initSelectionButtons();
    this.setupProductFormIntegration();
  }

  initSlider() {
    if (!this.slider || !this.progressBar) return;

    const updateProgress = () => {
      const scrollWidth = this.slider.scrollWidth;
      const clientWidth = this.slider.clientWidth;
      
      if (scrollWidth > clientWidth) {
        const thumbWidth = (clientWidth / scrollWidth) * 100;
        this.progressBar.style.width = `${thumbWidth}%`;
        
        const maxScroll = scrollWidth - clientWidth;
        const ratio = this.slider.scrollLeft / maxScroll;
        const trackFreeSpace = 100 - thumbWidth;
        this.progressBar.style.marginLeft = `${ratio * trackFreeSpace}%`;
      } else {
         this.progressBar.style.width = '100%';
         this.progressBar.style.marginLeft = '0';
      }
    };

    this.slider.addEventListener('scroll', updateProgress);
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  initVariantSelectors() {
    const selects = this.querySelectorAll('.et-cross-sell__select');
    selects.forEach(select => {
      select.addEventListener('change', (e) => this.handleVariantChange(e));
    });
  }

  handleVariantChange(e) {
    const select = e.target;
    const wrapper = select.closest('.et-cross-sell__select-wrapper');
    const card = select.closest('.et-cross-sell__card');
    const label = wrapper.querySelector('.et-cross-sell__selected-value');
    const priceDisplay = card.querySelector('.et-cross-sell__price');
    const addBtn = card.querySelector('.et-cross-sell__add-btn');
    const selectedOption = select.options[select.selectedIndex];

    label.textContent = selectedOption.text;
    
    if (priceDisplay) {
      priceDisplay.textContent = selectedOption.dataset.price;
    }

    if (addBtn) {
      addBtn.dataset.variantId = selectedOption.value;
      // Reset selection state when variant changes
      addBtn.classList.remove('et-selected');
    }
  }

  initSelectionButtons() {
    const addBtns = this.querySelectorAll('.et-cross-sell__add-btn');
    addBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleToggleSelection(e, btn));
    });
  }

  handleToggleSelection(e, btn) {
    e.preventDefault();
    
    const isSelected = btn.classList.contains('et-selected');
    
    if (isSelected) {
      btn.classList.remove('et-selected');
    } else {
      btn.classList.add('et-selected');
    }
    
    this.dispatchEvent(new CustomEvent('crosssell:selection-changed', { bubbles: true }));
  }

  getSelectedVariantIds() {
    const selectedBtns = this.querySelectorAll('.et-cross-sell__add-btn.et-selected');
    return Array.from(selectedBtns).map(btn => btn.dataset.variantId);
  }

  setupProductFormIntegration() {
    const productForm = document.querySelector('product-form');
    if (productForm) {
      const form = productForm.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => this.handleProductFormSubmit(e), true);
      }
    }
  }

  handleProductFormSubmit(e) {
    const selectedIds = this.getSelectedVariantIds();
    if (selectedIds.length === 0) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const form = e.target;
    const mainVariantId = form.querySelector('[name="id"]').value;
    const mainQtyInput = form.querySelector('[name="quantity"]');
    const mainQty = mainQtyInput ? parseInt(mainQtyInput.value) : 1;
    
    const items = [
      { id: parseInt(mainVariantId), quantity: mainQty },
      ...selectedIds.map(id => ({ id: parseInt(id), quantity: 1 }))
    ];
    
    this.addItemsToCart(items);
  }

  addItemsToCart(items) {
    const submitBtn = document.querySelector('.single-add-to-cart-button');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', true);
      submitBtn.classList.add('loading');
    }
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(response => response.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item: data } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
      
      // Reset all selections after successful add
      this.querySelectorAll('.et-cross-sell__add-btn.et-selected').forEach(btn => {
        btn.classList.remove('et-selected');
      });
    })
    .catch((error) => {
      console.error('Error adding items to cart:', error);
    })
    .finally(() => {
      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
      }
    });
  }
}

customElements.define('et-cross-sell', EcomTrafficCrossSell);
